import Vue from 'vue'
// @ts-ignore
import App from './App.vue'
import VueRouter from 'vue-router'
import BoostrapVue from 'bootstrap-vue'
// @ts-ignore
import router from './routes'
import firebase from 'firebase/app'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faTachometerAlt, faUsers, faFileInvoiceDollar, faProjectDiagram, faRocket, faUser, faEdit, faPlus, faEye, faFile, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
// @ts-ignore
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// @ts-ignore
import {ClientTable} from 'vue-tables-2';
import VeeValidate from 'vee-validate';
// @ts-ignore
import VueMoment from 'vue-moment';
import ToggleButton from 'vue-js-toggle-button';

const moment = require('moment');
require('moment/locale/de-at');
//moment().format('LTS');

library.add(faCoffee);
library.add(faTachometerAlt);
library.add(faUsers);
library.add(faFileInvoiceDollar);
library.add(faProjectDiagram);
library.add(faRocket);
library.add(faUser);
library.add(faEdit);
library.add(faPlus);
library.add(faEye);
library.add(faFile);
library.add(faPlusCircle);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.use(BoostrapVue);
Vue.use(VueRouter);
Vue.use(ClientTable);
Vue.use(VeeValidate);
Vue.use(VueMoment, {moment});
Vue.use(ToggleButton);

//console.log(Vue.moment().locale());
//console.log(moment().format('MMMM Do YYYY, h:mm:ss a'));

let app;

firebase.auth().onAuthStateChanged(() => {

    if (!app) {
        app = new Vue({
            render: h => h(App),
            router
        }).$mount('#app');
    }
});